import common from './common'

const disabled = {
  ...common.button,
  color: `omegaDark`,
  bg: `mute`,
  borderColor: ` mute`,
  cursor: `not-allowed`
}

export default disabled
